import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "card"]
  static values = { baseDelayMs: Number, perItemDelayMs: Number, transitionMs: Number }

  connect() {
    this.schedule()
  }

  schedule() {
    if (this.scheduled) return
    this.scheduled = true
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.scheduled = false
        this.show()
      })
    })
  }

  show() {
    if (!this.hasRowTarget || this.animating) return
    this.animating = true

    const baseDelay = this.hasBaseDelayMsValue ? this.baseDelayMsValue : 60
    const perItemDelay = this.hasPerItemDelayMsValue ? this.perItemDelayMsValue : 80
    const transition = this.hasTransitionMsValue ? this.transitionMsValue : 500

    const groups = this.rowTargets
      .map(row => {
        const cards = Array.from(row.querySelectorAll('[data-results-animation-target="card"]'))
        return cards.sort((a, b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left)
      })
      .filter(cards => cards.length)

    groups.forEach(cards => {
      cards.forEach(card => {
        card.classList.remove("opacity-100", "translate-y-0")
        card.classList.add("opacity-0", "-translate-y-6")
      })
    })

    requestAnimationFrame(() => {
      groups.forEach(cards => {
        cards.forEach(card => {
          card.classList.add("transform", "transition", "duration-500", "ease-[cubic-bezier(.34,1.56,.64,1)]")
        })
      })

      requestAnimationFrame(() => {
        groups.forEach(cards => {
          cards.forEach((card, i) => {
            setTimeout(() => {
              card.classList.remove("opacity-0", "-translate-y-6")
              card.classList.add("opacity-100", "translate-y-0")
            }, baseDelay + i * perItemDelay)
          })
        })
      })
    })

    const longest = Math.max(...groups.map(g => g.length))
    const total = baseDelay + Math.max(longest - 1, 0) * perItemDelay + transition
    setTimeout(() => { this.animating = false }, total)
  }
}
